import { change } from 'redux-form';
import { LengthLimits, UnitType, WeightLimits } from '../../../utils/enums';

export const checkForHeavyItems = (formData) => {
  const { measurementList, measurementType } = formData;

  const weightTotalLimitCheck = (measurementType && measurementType.name === UnitType.Imperial)
    ? WeightLimits.imperial.global
    : WeightLimits.metric.global;
  const weightUnitLimitCheck = (measurementType && measurementType.name === UnitType.Imperial)
    ? WeightLimits.imperial.each
    : WeightLimits.metric.each;

  let totalWeight = 0;
  let hasHeavyItems = false;

  if (measurementList) {
    measurementList.forEach((item) => {
      if (item.itemWeight) {
        totalWeight += Number(item.itemWeight);

        if (parseFloat(item.itemWeight) > weightUnitLimitCheck) {
          hasHeavyItems = true;
        }
      }
    });
  }

  if (totalWeight > weightTotalLimitCheck) {
    hasHeavyItems = true;
  }

  return hasHeavyItems;
};

export const checkForLargeItems = (formData) => {
  const { measurementList, measurementType } = formData;

  const lengthUnitLimitCheck = (measurementType && measurementType.name === UnitType.Imperial)
    ? LengthLimits.imperial.each
    : LengthLimits.metric.each;

  let hasLargeItems = false;

  if (measurementList) {
    measurementList.forEach((item) => {
      if (item.itemLength && parseFloat(item.itemLength) > lengthUnitLimitCheck) {
        hasLargeItems = true;
      }
    });
  }

  return hasLargeItems;
};

export const accessorialsMapping = (source) => {
  const groups = [];
  const services = [];
  source.children.forEach((group) => {
    const groupObj = { id: group.name, title: group.title.value };
    groups.push(groupObj);

    group.children.forEach((service) => {
      const obj = {
        ...service,
        idx: `acc${service.code.value}`,
        groupId: group.name,
        groupTitle: group.title.value,
      };
      services.push(obj);
    });
  });

  return { groups, services };
};

export const checkSpecialCases = (isUSShipment, isUSConsignee, hasHeavyItems, hasLargeItems, shipperIsResidential, consigneeIsResidential) => {
  const hasTLGPU = false;
  const hasTLGDL = false;
  const hasPRESPU = (shipperIsResidential);
  const hasPRESDL = (consigneeIsResidential);
  const hasAPPTDL = false;
  const hasCPASC = (isUSShipment);
  const has63 = (hasLargeItems && (isUSShipment || isUSConsignee));

  return {
    hasTLGPU, hasTLGDL, hasPRESPU, hasPRESDL, hasCPASC, hasAPPTDL, has63,
  };
};

export const filterServicesToShow = (checkingServices, servicesList, isUSShipment, isUSConsignee, isResidential) => {
  const servicesToShow = [];

  servicesList.forEach((item) => {
    if ((item.code.value === 'CPASC' || item.code.value === 'INBOND') && isUSShipment) {
      servicesToShow.push(item);
    }

    if (item.code.value === 'EXSVAL' && !isUSShipment) {
      servicesToShow.push(item);
    }

    if ((item.code.value === 'INSDPU' || item.code.value === 'INSDDL') && !isResidential) {
      servicesToShow.push(item);
    }

    if (checkingServices.indexOf(item.code.value) === -1) {
      servicesToShow.push(item);
    }
  });

  return servicesToShow;
};

export const getServicesFromForm = (formData) => {
  const formSelected = [];

  if (formData) {
    Object.entries(formData).forEach(([key, value]) => {
      if (value.selected) {
        const code = key.replace('acc', '');
        formSelected.push(code);
      }
    });
  }

  return formSelected;
};

export const serviceShouldBeDisabled = (service, cases, fieldsShouldBeBlocked) => {
  let disabled = false;
  const code = service && service.code && service.code.value && service.code.value.toString();

  if (code === 'HAZMAT') {
    disabled = true;
  }

  if (cases) {
    if (code === 'PRESPU' && cases.hasPRESPU) {
      disabled = true;
    }

    if (code === 'PRESDL' && cases.hasPRESDL) {
      disabled = true;
    }

    if (code === 'CPASC' && cases.hasCPASC) {
      disabled = true;
    }

    if (code === '63' && cases.has63) {
      disabled = true;
    }
  }

  if (service.additionalCharges.value === '1' && fieldsShouldBeBlocked) {
    disabled = true;
  }

  return disabled;
};

export const initAccessorialsForm = (source, formName, dispatch) => {
  const accessorialsObj = accessorialsMapping(source);
  const accList = {};

  accessorialsObj.services.forEach((service) => {
    accList[service.idx] = { ...service, selected: false };
  });

  dispatch(change(formName, 'accessorials', accList));
};
